<template>
  <router-view/>
</template>
<script>
import GoalsGuards from '@/guards/goals.guards'
export default {
  beforeRouteUpdate: GoalsGuards.onEnter
}
</script>



// WEBPACK FOOTER //
// src/views/app/goals/goals-view.vue